export default __webpack_public_path__ + "static/media/kape.60796a0c.jpg";